import React, { useEffect } from 'react';

import { isEmpty } from 'lodash';

import { bool } from 'prop-types';

import useRedirect from 'hooks/useRedirect';
import useUserRedux from 'hooks/useUserRedux';

/**
 * Contains all redirect logic strictly for counselor users
 */
const RedirectHelper = ({ isDashboardRedirect }) => {
  const {
    data: { grades, hasElementaryGrades, hasMiddleHighSchoolGrades },
  } = useUserRedux();
  const { redirect } = useRedirect();

  useEffect(() => {
    if (isDashboardRedirect) {
      const hasAllK12Grades = hasElementaryGrades && hasMiddleHighSchoolGrades;
      if (hasAllK12Grades) {
        // No need for route protection if we have all grades
        return;
      }
      // If only elementary grades are present, we need to enforce this redirect
      // logic and vice versa
      const isElementaryCounselor = hasElementaryGrades && !isEmpty(grades);
      const to = isElementaryCounselor ? '/el/dashboard' : '/dashboard';
      const reason = isElementaryCounselor
        ? 'elementary school counselor'
        : 'not an elementary school counselor';
      redirect({
        to,
        component: 'routes/CounselorRoutes/CounselorRedirects',
        reason,
      });
    }
  }, [grades, hasElementaryGrades, isDashboardRedirect]);

  return <></>;
};

RedirectHelper.propTypes = {
  isDashboardRedirect: bool,
};

RedirectHelper.defaultProps = {
  isDashboardRedirect: false,
};

export default RedirectHelper;
